<!-- page-wrapper Start-->
<div [ngClass]="layout.config.settings.layout_type"
     [class]="layout.config.settings.layout_version">
  <div class="page-wrapper" 
       id="canvas-bookmark"
       [ngClass]="layoutClass">
    <app-header></app-header>
    <app-sub-nav [Module]="_commonService.Module" [Menu]="_commonService.Menu"></app-sub-nav>
    <!-- Page Body Start-->
    <div class="page-body-wrapper" style="margin-top: 145px !important">
      <div class="sidebar-wrapper"
           [attr.sidebar-layout]="layout.config.settings.sidebar_type"
           [class.close_icon]="navServices.collapseSidebar">
        <app-sidebar [(menuItems)]="_commonService.SideBarMenu"></app-sidebar>
      </div>
      <div class="page-body" style="padding: 0px; min-height: calc(100vh - 52px);">
          <div class="container-fluid" style="padding:0px">
              <div class="row" style="margin:60px; margin-top:180px;">
                  <div [ngStyle]="{'display': _commonService.showTopAds}" id="topAds">
                      <iframe style="width: 100%; border: 0; height: 274px; padding: 0px;" src="https://my.gistec.com/store/bck_store-mygistec.html?v3=2.2.3"></iframe>
                  </div>
                  <main [@fadeInAnimation]="getRouterOutletState(o)" style="padding: 0px;">
                      <router-outlet #o="outlet"></router-outlet>
                  </main>
              </div>
          </div>
      </div>
      <!-- footer start-->
      <footer class="footer">
        <app-footer></app-footer>
      </footer>
      <!-- footer End-->
    </div>
    <!-- Page Body End-->
  </div>
</div>
<div class="bg-overlay1"></div>
<!--<app-customizer></app-customizer>-->
<!-- page-wrapper End-->